var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.fiscalDate
    ? _c(
        "el-tooltip",
        {
          attrs: {
            content: _vm.$t.__(
              "dashboard.cards.FiscalYearFooter.fiscal_year_start_date"
            ),
            placement: "bottom"
          }
        },
        [
          _c("span", { staticClass: "dinlineb p-3" }, [
            _vm._v(
              "\n        " +
                _vm._s(
                  _vm.$l10n.__("Depuis le %(fiscalDate)s", {
                    fiscalDate: _vm.fiscalDate
                  })
                ) +
                "\n    "
            )
          ])
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }